import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (!this.authService.isAuthenticated()) {
      // Если не авторизован, разрешаем доступ к login странице
      return true;
    }

    // Если уже авторизован, редиректим на home
    this.router.navigate(['/agents']);
    return false;
  }
}